var map = {
	"./Bulls_Eye.png": 290,
	"./_pong_golf.png": 291,
	"./ancient_temple.png": 292,
	"./arc_game.png": 293,
	"./bingo.png": 294,
	"./bounce_it.png": 295,
	"./break_the_ice.png": 296,
	"./car_cross.png": 297,
	"./cookie_mania.png": 298,
	"./coronavirus_prevention_icon.png": 299,
	"./crazy_ski_saga.png": 300,
	"./cruise_bingo.png": 301,
	"./cupids_arrow_icon.png": 302,
	"./electionHockey.png": 303,
	"./elf_on_the_slope.png": 304,
	"./fall_feast.png": 305,
	"./falling_fruits.png": 306,
	"./fish_spell.png": 307,
	"./football_frenzy.png": 308,
	"./football_frenzy1.png": 309,
	"./freedom_flight.png": 310,
	"./fright_flight.png": 311,
	"./galactic_surfer.png": 312,
	"./holly_jolly_slots.png": 313,
	"./jack-pot-of-gold.png": 314,
	"./jackpot.png": 315,
	"./ladybugs.png": 316,
	"./leprechauns_loot.png": 317,
	"./love_connection.png": 318,
	"./memory_shoot.png": 319,
	"./money_mania.png": 320,
	"./order_up.png": 321,
	"./pill_skill.png": 322,
	"./plinko.png": 323,
	"./pong_golf.png": 324,
	"./rock_climbing_ruins.png": 325,
	"./safely_home.png": 326,
	"./santa's_sleigh.png": 327,
	"./santas_sleigh.png": 328,
	"./scary_slots.png": 329,
	"./sequence_it.png": 330,
	"./ski_saga.png": 331,
	"./slot_machine.png": 332,
	"./slots_of_july.png": 333,
	"./slots_of_love.png": 334,
	"./slots_of_summer.png": 335,
	"./spaceship.png": 336,
	"./spooky_spiders.png": 337,
	"./st_pattys_plinko.png": 338,
	"./supermarket.png": 339,
	"./swinging_spiders.png": 340,
	"./take_flight.png": 341,
	"./turkey_hunt.png": 342,
	"./video_practice.png": 343
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 441;


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons ^\.\/.*$
// module id = 441
// module chunks = 0